module.exports = __webpack_public_path__ + "prod/1.42.2/img/renshi-one.8a427a59.png";